import React from 'react';

import { PageContent, TimeLine } from '@/modules/home';

const Home: React.FC = () => {
  return (
    <section className='relative flex flex-col gap-20'>
      <div className='relative flex flex-col-reverse gap-24 tablet:grid tablet:grid-cols-6 tablet:gap-32'>
        <PageContent />
        <TimeLine />
      </div>
    </section>
  );
};

export default Home;
